const verifyRequiredCustomFields = (customFields) => {
  const isEmptyValue = (value) => value === "" || value === "0.00" || value === "null"
   const hasRequiredCustomFieldsWithoutValue = customFields?.some(field => {
    return (
      (field.requiredIn === 2 || field.requiredIn === 3) && 
      (field.values.length === 0 || field.values.every(isEmptyValue))
    )
  });
  return hasRequiredCustomFieldsWithoutValue
}

export default verifyRequiredCustomFields